<div class="flex h-full gap-8 pb-20" *transloco="let t">
  <div class="flex min-w-0 flex-1 flex-col gap-2">
    <div>
      <div class="flex items-center gap-2">
        <h3 class="type-body-medium">{{ t("dsp-blacklist.active_title", { type: inventoryType() }) }}</h3>
        <IBadge [label]="(inventoryRowData().length | number: '1.0-0' : locale()) ?? ''" color="gray" variant="soft" />
      </div>
      <p class="type-label text-muted-foreground">
        {{
          t("dsp-blacklist.active_subtitle", {
            type: inventoryType(),
            start: periodStart() | date: "shortDate" : undefined : locale(),
            end: periodEnd() | date: "shortDate" : undefined : locale(),
          })
        }}
      </p>
    </div>
    <div class="ag-theme-quartz relative min-h-80 flex-1">
      @if (isInventoryLoading()) {
        <div class="absolute inset-0 z-10 flex items-center justify-center bg-white/70">
          <ISpinner />
        </div>
      }
      <ag-grid-angular
        class="h-full"
        [gridOptions]="inventoryGridOptions"
        [columnDefs]="inventoryGridColumnDefs()"
        [rowData]="inventoryRowData()"
      />
    </div>
  </div>
  <div class="flex min-w-0 flex-1 flex-col gap-2">
    <div class="flex items-center justify-between">
      <div>
        <div class="flex items-center gap-2">
          <h3 class="type-body-medium">{{ t("dsp-blacklist.blocked_title", { type: inventoryType() }) }}</h3>
          <IBadge
            [label]="
              t('dsp-blacklist.blocked_count', {
                count: blacklistedDomains().length | number: '1.0-0' : locale(),
                max: maxBlacklistEntries,
              })
            "
            color="gray"
            variant="soft"
          />
        </div>
        <p class="type-label text-muted-foreground">
          {{ t("dsp-blacklist.blocked_subtitle", { type: inventoryType() }) }}
        </p>
      </div>
      <div class="flex gap-2" [class.hidden]="!hasChanged()">
        <button iButton variant="ghost" (click)="resetChanges()" [disabled]="isLoading()">
          {{ t("common.discard_changes") }}
        </button>
        <button iButton (click)="saveChanges()" [loading]="isLoading()" [disabled]="isReadOnly()">
          {{ t("common.save") }}
        </button>
      </div>
    </div>
    <div class="ag-theme-quartz relative min-h-80 flex-1">
      @if (isBlacklistLoading()) {
        <div class="absolute inset-0 z-10 flex items-center justify-center bg-white/70">
          <ISpinner />
        </div>
      }
      <ag-grid-angular
        class="h-full"
        [columnDefs]="blacklistGridColumnDefs()"
        [rowData]="blacklistedDomains()"
        [getRowId]="blacklistRowId"
      />
    </div>
  </div>
</div>
